import type { AGENCY_VIEW, APP_VIEW, ORG_VIEW } from '../../../common/support/viewConstants';

declare global {
  interface Window {
    App: {
      context: {
        environment: string;
        flipper: {
          [flag: string]: boolean;
        };
        view: {
          app_id?: string;
          current_view?: typeof APP_VIEW | typeof AGENCY_VIEW | typeof ORG_VIEW;
          organization_id?: string;
        };
      };
    };
  }
}

export class FlipperService {
  constructor(private flipper) {}

  static getInstance() {
    return new FlipperService(window.App.context.flipper);
  }

  isActive(flag: string) {
    return this.flipper[flag];
  }
}
